import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "input-wrapper" }
const _hoisted_2 = { class: "uppercase text-raleway-13" }
const _hoisted_3 = { class: "account-select-double" }

import { GeoPlaceData } from "@/store/modules/GeoPlace/type";
import { IStore } from "@/store/types/StoreType";
import { computed, ref } from "vue";
import { useStore } from "vuex";

import SearchComponentLocation from "@/components/select/SearchComponentLocation.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'regionComponent',
  props: {
    error: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore<IStore>();


const region = ref(
  computed<{ data: GeoPlaceData[]; loading: boolean }>(
    () => store.getters.getRegionStockPostalcodeOptions
  )
);

const country = ref(
  computed<GeoPlaceData>(() => store.getters.getCountryStockSelectPostalCode)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$tc("region")), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(SearchComponentLocation, {
        name: 'region_stock',
        options: region.value.data,
        store: 'updateRegionStockSelectPostalCode',
        select: '',
        error: props.error || '',
        selectCallback: 'getCityStockPostalcode',
        noSelect: country.value === null
      }, null, 8, ["options", "error", "noSelect"])
    ])
  ]))
}
}

})